export default {
  name: "FormDialog",
  props: ['visible', "width", "title"],
  data: function data() {
    return {
      isSubmitting: false,
      form: null
    };
  },
  methods: {
    confirm: function confirm() {
      var _this = this;
      this.isSubmitting = true;
      this.$refs.form.validate(function (valid) {
        if (!valid) {
          _this.isSubmitting = false;
          return;
        }
        _this.$emit("submit", {
          complete: _this.close.bind(_this),
          reset: function reset() {
            _this.isSubmitting = false;
            _this.$refs.form.clearValidate();
          }
        });
      });
    },
    close: function close() {
      this.isSubmitting = false;
      this.$emit("update:visible", false);
      this.$refs.form.clearValidate();
    }
  }
};